export default __webpack_public_path__ + "static/media/III-2017.edd3ed79.pdf";